// extracted by mini-css-extract-plugin
export var colorSquare = "_jw-0";
export var danger = "_jw-5";
export var lightPink = "_jw-8";
export var neutralBlue = "_jw-7";
export var neutralYellow = "_jw-6";
export var normal = "_jw-1";
export var primary = "_jw-2";
export var primaryLight = "_jw-3";
export var solidBlack = "_jw-g";
export var solidGreen = "_jw-b";
export var solidLightBlue = "_jw-d";
export var solidNavy = "_jw-c";
export var solidOrange = "_jw-f";
export var solidPink = "_jw-e";
export var solidRed = "_jw-9";
export var solidYellow = "_jw-a";
export var success = "_jw-4";